import { render, staticRenderFns } from "./imgN.vue?vue&type=template&id=36fe9f15"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fe9f15')) {
      api.createRecord('36fe9f15', component.options)
    } else {
      api.reload('36fe9f15', component.options)
    }
    module.hot.accept("./imgN.vue?vue&type=template&id=36fe9f15", function () {
      api.rerender('36fe9f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgN.vue"
export default component.exports